import { colors } from "utils/constants";
import { Dropdown } from 'semantic-ui-react';
import { useState } from 'react';

const giftCardValues = [
  {
    key: 0,
    text: '£5',
    value: 2, // Duration in weeks
  },
  {
    key: 1,
    text: '£10',
    value: 4, // Duration in weeks
  },
  {
    key: 2,
    text: '£25',
    value: 10, // Duration in weeks
  },
  {
    key: 3,
    text: '£50',
    value: 20, // Duration in weeks
  },
  {
    key: 4,
    text: '£100',
    value: 40, // Duration in weeks
  },
  {
    key: 5,
    text: '£150',
    value: 60, // Duration in weeks
  },
];

const GiftCardValueSelector = ({ selectedDuration, onSelectHandler, style }) => {
  const [selectedGiftCardValue, setSelectedGiftCardValue] = useState(giftCardValues[0].value);

  return (
    <div className="giftCardDurationSelectorContainer flexCentered" style={style}>
      <Dropdown
        placeholder="Select Gift Card value"
        fluid
        selection
        options={giftCardValues}
        value={selectedGiftCardValue}
        onChange={(e, { value }) => {
          setSelectedGiftCardValue(value);
          onSelectHandler(value * 1);
        }}
      />

      <style jsx>{`
        .giftCardDurationSelectorContainer {
          display: flex;
          justify-content: space-between;
          border-radius: 7px;
          margin-bottom: 2em;
          min-width: 300px;
          width: 100%;
          max-width: 400px;
          box-shadow: inset -0.5px 1px 4px gray;
        }
        
        .additionalInfoContainer {
          position: absolute;
          bottom: -30px;
          left: calc(50% - 30px);
          font-weight: 600;
          font-size: 0.6em;
          white-space: nowrap;
          text-align: center;
          width: 100%;
        }
        
        .durationOption.selected .additionalInfoContainer {
          color: ${colors.primaryBrandGray};
          transform: scale(0.95);
          font-weight: bold;
        }
      `}</style>
    </div>
  );
};

export default GiftCardValueSelector;
